export const PRESSING_HISTORY_REQUEST = "PRESSING_HISTORY_REQUEST";
export const PRESSING_HISTORY_SUCCESS = "PRESSING_HISTORY_SUCCESS";
export const PRESSING_HISTORY_FAILED = "PRESSING_HISTORY_FAILED";